import type { Page } from '../../types';

const performanceConversationQ4: Page[] = [
  {
    pageType: 'question',
    title: 'Quarter 4 (January to March) - Performance Conversation',
    name: 'performance-q4',
    hidePageTitle: true,
    description:
      "Jobholder and line manager should hold a quarterly conversation to discuss performance to date, providing evidence against the 'what' and 'how' from minimum standards and objectives set",
    questions: [
      {
        questionType: 'radio',
        title:
          'Have you sought and received feedback via SCS 360 Tool having agreed nominations with your line manager?',
        name: 'talent-career-scs360-q4',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        textRows: 20,
        title: 'Summary',
        hint: 'In your summary, clearly refer to each minimum standard and each business objective, and explain how they are met',
        name: 'performance-summary-q4',
        placeholder:
          'This summary will be reviewed by panel chair ahead of moderation - please provide a clear concise summary of performance against minimum standards and business objectives',
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default performanceConversationQ4;
